import React from "react";

import {
  Button,
  Menu,
  MenuItem,
  Stack,
  Tooltip,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import AccountTreeIcon from "@mui/icons-material/AccountTree";
import ControlPointDuplicateIcon from "@mui/icons-material/ControlPointDuplicate";
import ContentPasteSearchIcon from "@mui/icons-material/ContentPasteSearch";
import LibraryAddOutlinedIcon from "@mui/icons-material/LibraryAddOutlined";
import { useDrawingBomContext } from "../DrawingBomContext";
import ChangeHistoryIcon from "@mui/icons-material/ChangeHistory";

import SimCardDownloadIcon from "@mui/icons-material/SimCardDownload";
import PrintToPDF from "../DrawingBomContext/PrintToPDF";
import { drawingMaterialsCols } from "../../Components/cols/drawingsMaterialsCols";
import { drawingMcsDataCols } from "../../Components/cols/drawingMaterialsMcsDataCols";
import { MaterialReactTable } from "material-react-table";
import { useBOMDashboardContext } from "../../BOMDashboard.context";
import { useEmsSidePanelContext } from "../../../../../../../../context/EmsSidePanelContext";

import LabelledBox from "../../../../../../../../components/widgets/LabelledBox";

const btnStyle = { mx: 0.4, my: 0.5, flexGrow: 1 };
export default function TabControl() {
  const {
    onConsolidate,
    onClickChangeOrder,
    onAddSrv,
    selectedDrawings,
    onCompare,
    onClickMtr,
  } = useDrawingBomContext();

  const printRef = React.useRef();

  const { setCurrentTab } = useBOMDashboardContext();

  const onClickReconcile = () => {
    setCurrentTab(4);
  };

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("lg"));
  const { open: emsPanelOpen } = useEmsSidePanelContext();
  const isMenu = isSmallScreen || emsPanelOpen;

  const [anchorEl, setAnchorEl] = React.useState(null);

  const actions = [
    {
      key: "validate",
      label: "Validate",
      icon: <ChangeHistoryIcon />,
      color: "success",
      onClick: onCompare,
    },
    {
      key: "consolidate",
      label: "Consolidate",
      icon: <ControlPointDuplicateIcon />,
      onClick: onConsolidate,
    },
    {
      key: "addSrv",
      label: "Add SRV",
      icon: <LibraryAddOutlinedIcon />,
      onClick: onAddSrv,
    },
    {
      key: "reconcile",
      label: "Reconcile",
      icon: <AccountTreeIcon />,
      onClick: onClickReconcile,
    },
    {
      key: "mtr",
      label: "MTR",
      icon: <ContentPasteSearchIcon />,
      onClick: onClickMtr,
      tooltip: "Material Traceability Record",
    },
    {
      key: "pdf",
      label: "Save as PDF",
      icon: <SimCardDownloadIcon />,
      onClick: () => {
        printRef.current.generatePDF();
        console.log({ selectedDrawings });
      },
      disabled: !selectedDrawings[0],
      tooltip: "Download a PDF file of selected Drawings data",
    },
  ];

  const renderAction = (a) => {
    const btn = (
      <Button
        variant="contained"
        color={a.color || "primary"}
        startIcon={a.icon}
        sx={btnStyle}
        onClick={a.onClick}
        disabled={a.disabled}
      >
        {a.label}
      </Button>
    );
    if (a.tooltip) {
      return (
        <Tooltip key={a.key} title={a.tooltip} placement="top">
          {btn}
        </Tooltip>
      );
    }
    return <React.Fragment key={a.key}>{btn}</React.Fragment>;
  };

  const printComponent = (
    <PrintToPDF
      ref={printRef}
      header={
        "Drawing Bom (No. " +
        selectedDrawings[0]?.dwgNumber +
        "(Rev: " +
        selectedDrawings[0]?.revision +
        ")) Details."
      }
      tableComponent={
        <MaterialReactTable
          columns={[
            ...drawingMaterialsCols(selectedDrawings[0]?.materials),
            ...drawingMcsDataCols,
          ]}
          // data={selectedDrawings[0]?.materials}
          data={selectedDrawings[0]?.materials || []}
          enableTopToolbar={false}
          enableBottomToolbar={false}
          enablePagination={false}
          enableColumnActions={false}
          enableSorting={false}
          enableFilters={false}
          enableFullScreenToggle={false}
          enableDensityToggle={false}
          initialState={{
            pagination: { pageSize: 50, pageIndex: 0 },
          }}
          muiTableHeadCellProps={{
            sx: {
              border: "0.5px solid rgba(81, 81, 81, .1)",
              // fontStyle: 'italic',
              fontWeight: "normal",
              padding: "10px",
              backgroundColor: "#f3f1fe",
            },
          }}
          muiTableBodyCellProps={{
            sx: {
              border: "1px solid rgba(81, 81, 81, .1)",
              padding: "10px",
            },
          }}
        />
      }
    />
  );

  if (isMenu) {
    return (
      <>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          sx={{ mt: "auto", mb: 0.5 }}
        >
          <Button
            variant="contained"
            endIcon={<MenuIcon />}
            onClick={(e) => setAnchorEl(e.currentTarget)}
          >
            Actions
          </Button>
        </Stack>
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          {actions.map((a) => (
            <MenuItem
              key={a.key}
              disabled={a.disabled}
              onClick={() => {
                a.onClick();
                setAnchorEl(null);
              }}
            >
              <Stack direction="row" spacing={1} alignItems="center">
                {a.icon}
                <span>{a.label}</span>
              </Stack>
            </MenuItem>
          ))}
        </Menu>
        {printComponent}
      </>
    );
  }

  return (
    <>
      <LabelledBox
        flexDirection="row-reverse"
        sx={{
          py: { xs: 1.5 },
          ml: { xs: 5, xl: 0 },
          // width: 500,
          // justifyContent: "space-between",
          // flexWrap: "wrap",
        }}
      >
        <Stack
          // spacing={{ xs: 1, sm: 2 }}
          direction="row"
          useFlexGap
          sx={{ flexWrap: "wrap" }}
        >
          {renderAction(actions[0])}
          {renderAction(actions[1])}
          {renderAction(actions[2])}
        </Stack>
        <Stack direction="row" useFlexGap sx={{ flexWrap: "wrap" }}>
          {renderAction(actions[3])}
          {renderAction(actions[4])}
          {renderAction(actions[5])}
        </Stack>

        {printComponent}
      </LabelledBox>
    </>
  );
}
